export const NotesPencilIcon = (props: React.HTMLAttributes<SVGElement>) => {
  const { className, ...rest } = props;

  return (
    <svg
      width='225'
      height='225'
      viewBox='0 0 225 225'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        d='M23 48.746C23 40.0497 30.1634 33 39 33H133C141 40.873 154 54.1587 160 60.0635V203.254C160 211.95 152.837 219 144 219H39C30.1634 219 23 211.95 23 203.254V48.746Z'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinejoin='round'
      />
      <path
        d='M47 90H128'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M47 112H103'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M47 136H103'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M47 157H103'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M88 191L126 191'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M128.5 34.5L128.5 64.4999L158.5 64.4999'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M147.958 173.874L215.874 105.958C222.219 99.6136 222.219 89.6639 215.874 83.3194C209.53 76.9749 199.58 76.9749 193.235 83.3194L125.319 151.236V173.874H147.958Z'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M181.914 94.6388L204.553 117.278'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
